const IS_ANDROID = !!navigator.userAgent.match(/Android/i);
const IS_IOS = ['iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
const IS_MOBILE = IS_ANDROID || IS_IOS;

const IN_IFRAME = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (error) {
    // In case of cross-origin iframe, accessing window.top throws an error
    return true;
  }
};

export const BrowserUtils = {
  IS_MOBILE,
  IN_IFRAME,
};
